/* Littl 2027 — quick view. Any link to a product page opens a sheet instead
   (bottom sheet on mobile, side drawer on desktop). The link stays a real link,
   so Google, "open in new tab" and ctrl/cmd-click still reach the product page.
   Skip a link with data-no-qv. Sheet content: sections/littl-quick-view.liquid */
(() => {
  if (window.__lQV) return;
  window.__lQV = true;

  const R = window.routes || {};
  const addUrl = (R.cart_add_url || '/cart/add') + '.js';
  const cartJs = (R.cart_url || '/cart') + '.js';
  const SKIP = '[data-no-qv], [data-l-header], header, footer, nav, .rte, form, cart-drawer, .l-qv__foot';
  const cache = new Map();
  let shell, panel, body, isOpen = false, pushed = false, lastFocus = null, token = 0;

  const money = (paise) => {
    const cur = (window.littl && window.littl.currency) || 'INR';
    const n = Number(paise) / 100;
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return '₹' + n; }
  };

  const productPath = (a) => {
    if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return null;
    let u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    const m = u.pathname.match(/^((?:\/[a-z]{2}(?:-[a-z]{2})?)?)(?:\/collections\/[^/]+)?\/products\/([^/?#]+)\/?$/i);
    return m ? `${m[1]}/products/${m[2]}` : null;
  };
  const disabledHere = () => window.littl && window.littl.template === 'cart';
  const eligible = (a) => !disabledHere() && !a.closest(SKIP) && productPath(a);

  const load = (path) => {
    if (!cache.has(path)) {
      const p = fetch(`${path}?section_id=littl-quick-view`, { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error('qv ' + r.status); return r.text(); })
        .catch((e) => { cache.delete(path); throw e; });
      cache.set(path, p);
    }
    return cache.get(path);
  };

  const build = () => {
    shell = document.createElement('div');
    shell.className = 'l-qv';
    shell.hidden = true;
    shell.innerHTML =
      '<div class="l-qv__back" data-qv-close></div>' +
      '<div class="l-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<div class="l-qv__grab" data-qv-grab><i></i></div>' +
        '<button type="button" class="l-qv__x" aria-label="Close" data-qv-close>' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="l-qv__body" data-qv-body></div>' +
      '</div>';
    document.body.appendChild(shell);
    panel = shell.querySelector('.l-qv__panel');
    body = shell.querySelector('[data-qv-body]');
    wire();
  };

  const track = (el) => {
    const d = el.dataset;
    const price = Number(d.qvPrice) / 100;
    const cur = (window.littl && window.littl.currency) || 'INR';
    try { if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', { content_ids: [d.qvProduct], content_type: 'product_group', content_name: d.qvTitle, value: price, currency: cur }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'view_item', { currency: cur, value: price, items: [{ item_id: d.qvProduct, item_name: d.qvTitle, price }] }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('littl_quick_view', { productId: d.qvProduct, variantId: d.qvVariant, title: d.qvTitle, price, currency: cur, url: d.qvUrl }); } catch (e) {}
  };

  const open = async (path, swap) => {
    if (!shell) build();
    const my = ++token;
    if (!isOpen) {
      lastFocus = document.activeElement;
      shell.hidden = false;
      void shell.offsetWidth;
      shell.classList.add('is-open');
      document.documentElement.classList.add('l-qv-lock');
      isOpen = true;
      if (!pushed) { history.pushState({ lqv: 1 }, ''); pushed = true; }
    }
    if (!swap) body.innerHTML = '<div class="l-qv__skel" aria-hidden="true"><i></i><b></b><b></b></div>';
    body.classList.add('is-loading');
    try {
      const html = await load(path);
      if (my !== token || !isOpen) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.l-qv__in');
      if (!inner) throw new Error('qv empty');
      body.replaceChildren(inner);
      body.scrollTop = 0;
      setup(inner);
      track(inner);
      if (!swap) { const x = shell.querySelector('.l-qv__x'); if (x) x.focus({ preventScroll: true }); }
    } catch (e) {
      if (my === token) location.href = path;
    } finally {
      body.classList.remove('is-loading');
    }
  };

  const close = (fromPop) => {
    if (!isOpen) return;
    isOpen = false;
    token++;
    shell.classList.remove('is-open');
    document.documentElement.classList.remove('l-qv-lock');
    setTimeout(() => { if (!isOpen) { shell.hidden = true; body.replaceChildren(); } }, 320);
    if (pushed) { pushed = false; if (!fromPop) history.back(); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  /* per-product setup: gallery indicator, variants, quantity */
  const setup = (el) => {
    const gal = el.querySelector('[data-qv-gal]');
    const bars = el.querySelectorAll('.l-qv__bar i');
    if (gal && bars.length) {
      gal.addEventListener('scroll', () => {
        const w = gal.firstElementChild ? gal.firstElementChild.getBoundingClientRect().width + 8 : 1;
        const i = Math.min(bars.length - 1, Math.round(gal.scrollLeft / w));
        bars.forEach((b, k) => b.classList.toggle('is-on', k === i));
      }, { passive: true });
    }
    const sel = el.querySelector('.l-qv__sw.is-on');
    if (sel) sel.scrollIntoView({ block: 'nearest', inline: 'center' });
    el._qty = 1;
    el._variant = el.dataset.qvVariant;
    el._price = Number(el.dataset.qvPrice);
    try { el._vars = JSON.parse(el.querySelector('[data-qv-variants]').textContent); } catch (e) { el._vars = []; }
    const cur = el._vars.find((x) => String(x.id) === String(el._variant));
    el._opts = cur ? cur.options.slice() : [];
  };

  /* choose a colour / option value inside a product */
  const choose = (el, idx, val) => {
    const opts = el._opts.slice(); opts[idx] = val;
    const same = (x) => x.options.every((o, i) => o === opts[i]);
    let pick = el._vars.find(same);
    if (!pick) pick = el._vars.find((x) => x.options[idx] === val && x.available) || el._vars.find((x) => x.options[idx] === val);
    if (!pick) return;
    el._opts = pick.options.slice();
    el._variant = String(pick.id);
    el._price = pick.price;
    el.querySelectorAll('[data-qv-opt]').forEach((b) => {
      const on = b.dataset.val === el._opts[Number(b.dataset.qvOpt)];
      if (b.classList.contains('l-qv__sw')) b.classList.toggle('is-on', on); else b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    el.querySelectorAll('[data-qv-optlabel]').forEach((l) => { l.textContent = el._opts[Number(l.dataset.qvOptlabel)]; });
    el.querySelector('[data-qv-price-label]').textContent = money(pick.price);
    const c = el.querySelector('[data-qv-compare]');
    if (c) { const cp = pick.compare_at_price || 0; c.hidden = !(cp > pick.price); if (cp > pick.price) c.textContent = money(cp); }
    const add = el.querySelector('[data-qv-add]');
    add.classList.remove('is-added');
    add.disabled = !pick.available;
    if (pick.available) add.innerHTML = `Add to cart · <span data-qv-total>${money(el._price * el._qty)}</span>`; else add.textContent = 'Sold out';
    const nf = el.querySelector('[data-qv-notify]'); if (nf) nf.hidden = !!pick.available;
    /* live summary line for width products, e.g. "Crimson & Scarlet · 12 mm · 47 m roll" */
    const sel = el.querySelector('[data-qv-sel]');
    if (sel) {
      const ci = Number(el.dataset.qvCi), wi = Number(el.dataset.qvWi);
      const lead = ci >= 0 ? el._opts[ci] : el.dataset.qvLead;
      sel.textContent = [lead, el._opts[wi]].filter(Boolean).join(' · ');
    }
    /* the chosen colour / width's own photo moves to the front of the gallery;
       a width / colour without its own photo falls back to the product's main photo */
    const mid = (pick.featured_media && pick.featured_media.id) || el.dataset.qvFirst;
    const gal = el.querySelector('[data-qv-gal]');
    const slide = mid && gal && gal.querySelector(`[data-media-id="${mid}"]`);
    if (slide) {
      if (gal.firstElementChild !== slide) gal.prepend(slide);
      gal.scrollTo({ left: 0, behavior: 'smooth' });
      el.querySelectorAll('.l-qv__bar i').forEach((b, k) => b.classList.toggle('is-on', k === 0));
    }
  };

  const refresh = (el) => {
    const t = el.querySelector('[data-qv-total]');
    if (t) t.textContent = money(el._price * el._qty);
    el.querySelector('[data-qv-qty]').textContent = el._qty;
    const add = el.querySelector('[data-qv-add]');
    if (add && add.classList.contains('is-added')) resetAdd(el);
  };
  const resetAdd = (el) => {
    const add = el.querySelector('[data-qv-add]');
    add.classList.remove('is-added');
    add.innerHTML = `Add to cart · <span data-qv-total>${money(el._price * el._qty)}</span>`;
  };

  const addToCart = async (el) => {
    const add = el.querySelector('[data-qv-add]');
    const err = el.querySelector('[data-qv-err]');
    if (add.disabled) return;
    add.disabled = true; add.classList.add('is-loading'); err.hidden = true;
    try {
      const r = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(el._variant), quantity: el._qty }] })
      });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || 'Could not add to cart. Please try again.'); }
      /* show "Added" straight away; refresh cart totals in the background */
      add.classList.add('is-added');
      add.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Added to cart';
      fetch(cartJs, { headers: { Accept: 'application/json' } }).then((x) => x.json()).then((cart) => {
        document.dispatchEvent(new CustomEvent('littl:cart-changed', { detail: { cart } }));
        const link = el.querySelector('[data-qv-cart]');
        if (link) {
          link.querySelector('[data-qv-cartsum]').textContent = `${cart.item_count} ${cart.item_count === 1 ? 'roll' : 'rolls'} · ${money(cart.total_price)}`;
          link.hidden = false;
        }
      }).catch(() => {});
    } catch (e) {
      err.textContent = e.message; err.hidden = false;
    } finally {
      add.classList.remove('is-loading'); add.disabled = false;
    }
  };

  const wire = () => {
    shell.addEventListener('click', (e) => {
      if (e.target.closest('[data-qv-close]')) { close(); return; }
      const el = body.querySelector('.l-qv__in');
      if (!el) return;
      /* tapping the photo opens the full product page */
      if (e.target.closest('.l-qv__s')) { location.href = el.dataset.qvUrl; return; }
      const sw = e.target.closest('[data-qv-open]');
      if (sw) { if (!sw.classList.contains('is-on')) open(sw.dataset.qvOpen, true); return; }
      const q = e.target.closest('[data-qv-q]');
      if (q) { el._qty = Math.max(1, el._qty + Number(q.dataset.qvQ)); refresh(el); return; }
      const ob = e.target.closest('[data-qv-opt]');
      if (ob) { choose(el, Number(ob.dataset.qvOpt), ob.dataset.val); return; }
      if (e.target.closest('[data-qv-add]')) {
        const add = el.querySelector('[data-qv-add]');
        if (add.classList.contains('is-added')) { resetAdd(el); return; }
        addToCart(el);
      }
    });

    /* drag the handle down to close (mobile) */
    const grab = shell.querySelector('[data-qv-grab]');
    let y0 = null, dy = 0;
    grab.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
    grab.addEventListener('touchmove', (e) => { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = `translateY(${dy}px)`; }, { passive: true });
    grab.addEventListener('touchend', () => {
      panel.style.transition = ''; panel.style.transform = '';
      if (dy > 90) close();
      y0 = null;
    });
  };

  /* open on tap of any product link */
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]');
    if (!a || (shell && shell.contains(a))) return;
    const path = eligible(a);
    if (!path) return;
    e.preventDefault();
    open(path, false);
  });

  /* warm the cache as a finger lands or the mouse rests on a product link */
  const warm = (e) => {
    const a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const path = eligible(a);
    if (path) load(path).catch(() => {});
  };
  /* desktop only: on phones a finger touches many product links while scrolling,
     and fetching each one would compete with the product photos loading */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', (e) => { clearTimeout(warm._t); warm._t = setTimeout(() => warm(e), 250); });
  }

  /* any press outside the sheet / drawer closes it (and that press does nothing else) */
  let swallow = false;
  document.addEventListener('pointerdown', (e) => {
    if (!isOpen || !panel || panel.contains(e.target)) return;
    swallow = true;
    close();
  }, true);
  document.addEventListener('click', (e) => {
    if (!swallow) return;
    swallow = false;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  /* other sections (e.g. Shop the look markers) can open a product in the sheet */
  window.littlQuickView = (url) => { const path = productPath({ href: url, target: '', hasAttribute: () => false }); if (path && !disabledHere()) open(path, false); else if (url) location.href = url; };

  window.addEventListener('popstate', () => { if (isOpen) { pushed = false; close(true); } });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen) close(); });
})();
